exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".About{background-color:#fff;padding:60px 0;border-bottom:2px solid #e0e0e0;text-align:center}.About #block7 p{text-align:left}.About #block7 .button-storm{text-align:center}.About section{padding:0}.About p{color:#222831;font-size:1.6em;line-height:24px;margin-bottom:5px}.About p:last-child{margin-bottom:0}@media (max-width:1024px){.About .container{max-width:100%;width:calc(100% - 30px);padding:0 15px}.About .container article{padding:0}}@media (max-width:640px){.About p{text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b9c0dae","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/About.vue
// module id = 79
// module chunks = 0